import React from 'react'

import useStyles from './responsive-container.style'

const ResponsiveContainer = ({
  children, className, onScroll, 'data-testid': dataTestId, ...props
}) => {
  const classes = useStyles(props)

  return (
    <div
      className={`${className} ${classes.wrapper}`}
      data-testid={dataTestId}
      onScroll={onScroll}
    >
      {children}
    </div>
  )
}

export default ResponsiveContainer
